import { classnames } from '@tailwindcss-classnames';

export const detailsHeading = classnames('h4');

export const headingLabel = classnames(
  'text-nzxt-light-grey-500',
  'text-xs',
  'pb-4'
);
export const topAddressSection = classnames('space-y-2');

export const addressColumn = classnames('p-4', 'md:p-0', 'text-sm');

export const hoursSection = classnames('pt-4', 'md:pt-4');

export const contactButton = classnames(
  'my-4',
  'max-w-xs',
  'ml-4',
  'md:ml-0',
  'w-full'
);
